import * as types from "../constants/ActionTypes";

const routerGroupGroupedByMidiaId = (state = null, action) => {
  switch (action.type) {
    case types.ADD_ROUTER_GROUP_GROUPED_BY_MIDIA_ID:
      return action.payload;
    default:
      return state;
  }
};

export default routerGroupGroupedByMidiaId;
